import { render, staticRenderFns } from "./platformTaskList.vue?vue&type=template&id=3c1393ac&scoped=true"
import script from "./platformTaskList.vue?vue&type=script&lang=js"
export * from "./platformTaskList.vue?vue&type=script&lang=js"
import style0 from "./platformTaskList.vue?vue&type=style&index=0&id=3c1393ac&prod&lang=css"
import style1 from "./platformTaskList.vue?vue&type=style&index=1&id=3c1393ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1393ac",
  null
  
)

export default component.exports